<template>
  <ion-page>
    <ion-content class="h-full">
      <round-header
        image-type="component"
        :image="HeartHandshake"
        title="Toolbox"
        disable-edit-mode="true"
      >
      </round-header>
      <div id="container">
        <div class="flex flex-wrap justify-center">
          <category-button
            icon="🧘"
            class="bg-bg-neutral m-4"
            icon-class="sepia"
            @click="router.push('/tools/stress')"
          />
          <category-button
            icon="⏱️"
            class="bg-bg-neutral m-4"
            icon-class="sepia"
            @click="router.push('/tools/pomodoro')"
          />
          <category-button
            icon="😊"
            class="bg-bg-neutral m-4"
            icon-class="sepia"
            @click="router.push('/tools/mood')"
          />
          <category-button
            icon="🙏"
            class="bg-bg-neutral m-4"
            icon-class="sepia"
            @click="router.push('/tools/gratitude')"
          />
          <category-button
            icon="🤕"
            class="bg-bg-neutral m-4"
            icon-class="sepia"
            @click="router.push('/tools/headache')"
          />
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { IonContent, IonPage } from '@ionic/vue';
import RoundHeader from '../components/RoundHeader.vue';
import router from '../router';
import CategoryButton from '../components/CategoryButton.vue';
import { HeartHandshake } from 'lucide-vue-next';
</script>
